<template>
  <div class="packages-control">
    <div class="row">
      <div class="small-3 columns padding-R">
        <a class="button cta block xsmall" href="javascript:;" @click="moveToPool">MOVE TO POOL</a>
      </div>
      <div class="small-3 columns">
        <a class="button cta block xsmall warning" href="javascript:;" @click="removeFromPool">REMOVE FROM POOL</a>
      </div>
      <div class="small-3 columns padding-L">
        <a :class="{'button cta block xsmall error':true, 'disabled':disableBreakPkg}" href="javascript:;" @click="breakPackage">BREAK PACKAGE</a>
      </div>
      <div class="columns small-3 padding-L">
        <a class="button cta success block xsmall" href="javascript:;"
          @click="markAsComplete">MARK AS COMPLETE</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tnc-reservations-control',
  data () {
    return {
      disableBreakPkg: false
    }
  },
  computed: {
    checkPkgs () { return this.$store.state.laxit.tncReservations.checked }
  },
  methods: {
    isValid (title, message) {
      let self = this
      let checkedPackages = self.$store.state.laxit.tncReservations.checked
      if (checkedPackages.length <= 0 || checkedPackages.length > 1) {
        self.$store.commit('laxit/showRoutingModal')
        self.$store.commit('laxit/setRoutingValidationModal', {
          show: true,
          title: title,
          message: message
        })
        return false
      }
      return true
    },
    moveToPool () {
      let self = this
      if (!self.isValid('You missed something', 'Please select only 1 reservation/package to move to the pool.')) {
        return
      }

      let tncReservations = self.$store.state.laxit.tncReservations
      let checkedId = tncReservations.checked[0]
      let index = tncReservations.list.findIndex(x => x.id === checkedId)
      let checkedData = tncReservations.list[index]
      let url = checkedData.type === 'rsvp' ? '/admin/rsvp/' : '/admin/package/'

      self.$store.commit('laxit/showRoutingModal')
      let type = checkedData.type === 'rsvp' ? 'reservation' : 'package'
      self.$store.commit('laxit/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: `Moving ${type} to pool...`
      })
      self.$sdk.post(url + checkedId + '/pool', {
        token: self.$store.state.session.sessionToken
      }, r => {
        let success = true
        let message = `Successfully moved ${type} ${checkedId} to the pool.`
        if (r.error) {
          console.log(r)
          success = false
          message = 'Oops. Something went wrong. Please try again later.'
        } else {
          self.$store.commit('laxit/setTncReservationsChecked', [])
        }
        self.$store.commit('laxit/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        })

        setTimeout(() => {
          self.$store.commit('laxit/hideRoutingModal')
        }, 1000)
      })
    },
    removeFromPool () {
      let self = this
      if (!self.isValid('You missed something', 'Please select only 1 reservation/package to remove from the pool.')) {
        return
      }

      let checkedPackages = self.$store.state.laxit.tncReservations.checked

      let tncReservations = self.$store.state.laxit.tncReservations
      let checkedId = tncReservations.checked[0]
      let index = tncReservations.list.findIndex(x => x.id === checkedId)
      let checkedData = tncReservations.list[index]
      let url = checkedData.type === 'rsvp' ? '/admin/rsvp/' : '/admin/package/'

      self.$store.commit('laxit/showRoutingModal')
      let type = checkedData.type === 'rsvp' ? 'reservation' : 'package'
      self.$store.commit('laxit/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: `Removing to ${type} ${checkedId} pool...`
      })
      self.$sdk.delete(url + checkedId + '/pool', {
        token: self.$store.state.session.sessionToken
      }, r => {
        let success = true
        let message = `Successfully removed ${type} ${checkedId} from the pool.`
        if (r.error) {
          console.log(r)
          success = false
          message = 'Oops. Something went wrong. Please try again later.'
        } else {
          self.$store.commit('laxit/setTncReservationsChecked', [])
        }
        self.$store.commit('laxit/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        })

        setTimeout(() => {
          self.$store.commit('laxit/hideRoutingModal')
        }, 1000)
      })
    },
    breakPackage () {
      let self = this
      let tncReservations = self.$store.state.laxit.tncReservations
      let checkedId = tncReservations.checked[0]
      let index = tncReservations.list.findIndex(x => x.id === checkedId)
      let checkedData = tncReservations.list[index]

      if (checkedData.type === 'rsvp') {
        self.$store.commit('laxit/showRoutingModal')
        self.$store.commit('laxit/setRoutingValidationModal', {
          show: true,
          title: 'Oops',
          message: 'Please select only package to break.'
        })
        return
      }

      if (!self.isValid('You missed something', 'Please select only 1 package to break.')) {
        return
      }

      self.$store.commit('laxit/showRoutingModal')
      self.$store.commit('laxit/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: `Breaking package ${checkedId}...`
      })
      self.$sdk.delete('/admin/package/' + checkedId, {
        token: self.$store.state.session.sessionToken
      }, r => {
        let success = true
        let message = `Successfully broken package ${checkedId}.`
        if (r.error) {
          console.log(r)
          success = false
          message = 'Oops. Something went wrong. Please try again later.'
        }
        self.$store.commit('laxit/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        })

        if (success) {
          // self.$store.commit('laxit/removePackageItem', checkedId)
          self.$store.commit('laxit/removeTncReservationsChecked')
        }

        setTimeout(() => {
          self.$store.commit('laxit/hideRoutingModal')
        }, 1000)
      })
    },
    markAsComplete () {
      let self = this

      let tncReservations = self.$store.state.laxit.tncReservations
      let checkedId = tncReservations.checked[0]
      let index = tncReservations.list.findIndex(x => x.id === checkedId)
      let checkedData = tncReservations.list[index]

      // let rsvps = self.$store.state.laxit.tncReservations.checked
      if (!self.isValid('Oops. You missed something.', 'Please select only 1 reservation/package to mark as complete.')) {
        return
      }

      if (!self.canMarkAsComplete(checkedData)) {
        self.$store.commit('laxit/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You cannot mark as complete Cancelled or Completed reservations/packages.'
        })
        return
      }

      // let rsvp = rsvps[0]

      self.$store.commit('reservationNotes/show', {
        show: true,
        rsvpId: checkedData.id,
        isPackage: checkedData.type !== 'rsvp',
        forComplete: true
      })
      return
    },
    canMarkAsComplete (items) {for (let i = 0; i < items.length; i++) {
      let item = items[i]
      if (item.status === 'complete' ||
        item.status === 'completed' ||
        item.status === 'canceled') {
      return false
      }
    }
    return true
    }
  },
  watch: {
    checkPkgs (value) {
      let pkgs = this.$store.state.laxit.tncReservations.list
      this.disableBreakPkg = false
      for (let index in value) {
        let pkgIndex = pkgs.findIndex(x => x.id === value[index])
        if (pkgs[pkgIndex].driver && pkgs[pkgIndex].driver.ID) {
          this.disableBreakPkg = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.padding-L { padding-left: 7px; }
.padding-R { padding-right: 7px; }
.button.cta{ font-size: 11px; }
</style>



// WEBPACK FOOTER //
// src/components/Laxit/TncReservationsControl.vue